import { EColors, EFonts, EVariables } from "libs/style/w24_styling"
import React from "react"
import styled from "styled-components/macro"

interface Props {
  title: string
  description: string
  className?: string
}

export const GreyPhotoBox = (props: Props): JSX.Element => {
  return (
    <S_GreyPhotoBox className={props.className}>
      <S_Photo />
      <S_Title>{props.title}</S_Title>
      <S_Description>{props.description}</S_Description>
    </S_GreyPhotoBox>
  )
}

const S_GreyPhotoBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 25px;
  border-radius: ${EVariables.Radius2};
  background-color: ${EColors.GREY2};
  width: 100%;

  @media only screen and (min-width: 1260px) {
    padding: 37px 42px;
    width: 380px;
    height: 565px;
  }
`

const S_Photo = styled.div`
  width: 80px;
  height: 80px;
  background: url("/jan.png") no-repeat;
  background-size: cover;
  border-radius: ${EVariables.Radius1};
  @media only screen and (min-width: 1260px) {
    width: 100%;
    height: 296px;
  }
`

const S_Title = styled.div`
  color: ${EColors.DARK};
  font-family: ${EFonts.Bold};
  font-size: 18px;
  letter-spacing: ${EVariables.Spacing2};
  margin: 18px 0 12px 0;
  @media only screen and (min-width: 1260px) {
    font-size: 25px;
    margin: 35px 0 22px 0;
  }
`

const S_Description = styled.div`
  color: ${EColors.DARK2};
  font-family: ${EFonts.Medium2};
  font-size: 15px;
  line-height: 28px;
  @media only screen and (min-width: 1260px) {
    font-size: 18px;
    line-height: 37px;
  }
`
